import React, { Component, MouseEvent } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil } from "@eres/core";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import * as SSO from "@10x/sso";
import { getParticipantID, hasRole } from "@10x/sso";
import { eidFormat, hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { emailF, phoneNumber } from "./index";
import { dispatch, navigate, navigateWithInParent } from "@my-dld/utils/StoreUtils";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageContent from "@my-dld/components/PageContent";
import { TabuProfile, TabuVIPCategory } from "@10x/sso/TabuProfile";
import { TABU_OWNER } from "@10x/sso/roles";
import { VIPOwnerAPI } from "@eres/vipownerapi";
import { trackEvent, trackEventWithData } from "@my-dld/utils/Analytics";
import { getVIPCategory, refreshTabuProfile, setTabuUser } from "@my-dld/utils/User";
import { getOwnerVIPCategoryLabel } from "@my-dld/components/VIPOwner/ContactManager";
import Action from "@my-dld/actions";
import GreenList from "@my-dld/components/GreenList/GreenList";
import { ProfileImage } from "@my-dld/components/ProfileImage";
import SSOVerifyPopup from "./SSOVerifyPopup";
import { SSOApi } from "@eres/ssoapi";
import { exToMessage } from "@eres/ssoapi/api";
import { ProfileUpdateRequest, ProfileUpdateResponse, SSOResponse } from "@eres/ssoapi/entities";
import { isSSOUser, isSSPProfileUpdateOTPDisabled } from "@my-dld/utils/Utils";

interface Props extends RoutedViewProps {

}

interface State {
	name: LocaleValue;
	email: string;
	mobile: string;
	eid: string;
	isTabuUser: boolean;
	participantNumber?: string;
	vipCategory?: TabuVIPCategory;
	showEmailVerification?: boolean;
	showOTP: boolean;
}

function verifyApiAdapter( request: ProfileUpdateRequest ): Promise<SSOResponse<ProfileUpdateResponse>> {
	return SSOApi.profile.verifyUpdateToken( request ).then( r => {
		if ( r?.data === "Success" ) {
			return {
				email: { status: "VERIFIED" }
			} as ProfileUpdateResponse;
		}
		return {
			email: { status: "OLD" }
		} as ProfileUpdateResponse;
	} ).then( x => {
		return { data: x } as SSOResponse<ProfileUpdateResponse>;
	} );
}

export default class ViewMyProfile extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		let showEmailVerification = false;
		let tabuProfile = TabuProfile.getProfile();
		if ( tabuProfile && !tabuProfile.isEmailVerified ) {
			showEmailVerification = true;
		}
		this.state = {
			showEmailVerification: showEmailVerification,
			name: SSO.getName()!,
			email: emailF(),
			mobile: phoneNumber(),
			eid: eidFormat( SSO.getEmiratesID() ),
			isTabuUser: tabuProfile != null,
			vipCategory: getVIPCategory(),
			showOTP: false,
		};
	}

	onEdit = ( e: MouseEvent ) => {
		e.preventDefault();
		if (isSSOUser()) {
			if ( isSSPProfileUpdateOTPDisabled() ) {
				navigateWithInParent( "profile", "edit" );
			} else {
				showLoading();
				SSOApi.profile.createUpdateToken()
				.then( response => {
					hideLoading();
					if ( response.data === "Success" ) {
						trackEvent( "EditProfileInit", "VerifyOTPSend" );
						this.setState( { showOTP: true } );
					}
				} )
				.catch( ( ex: any ) => {
					trackEvent( "EditProfileInit", "VerifyOTPSendError" );
					return exToMessage( ex ).then( msg => {
						hideLoading();
						showErrorMessage( msg.error ?? ex );
					} );
				} );
			}
		} else {
			navigateWithInParent( "profile", "edit" );
		}
	};
	updateProfileFromApi = () => {
		showLoading();
		refreshTabuProfile( profile => {
			hideLoading();
			setTabuUser( profile );
			this.setState( {
				showEmailVerification: !profile.isEmailVerified,
			} );
		}, error => {
			hideLoading();
		} );
	};

	componentDidMount() {
		if ( hasRole( TABU_OWNER ) ) {
			this.updateProfileFromApi();
			this.loadOwnerCategory();
		}
	}

	render() {

		const {
			name, mobile, eid, email, isTabuUser, vipCategory,
			showEmailVerification, showOTP
		} = this.state;
		return <PageContent
			title={ Strings.my_profile } hideQLinks={false}
            titleExtra={<a href="#" onClick={this.onEdit} className="btn btn-grey btn-edit">
                <i className="material-icons-outlined">edit_square</i>
				{ Strings.edit_profile }
			</a> }>
			<PageTitle title={ Strings.my_profile } paths={ [ DashboardBCItem ] }/>
            <div className="card mydld-profile">
                <a className="profile-img-link">
                    <ProfileImage />
                </a>
                <div className="flex-grid mb-0">
                    <div>
                        <span>{Strings.name} :</span>
                        <span>{LocaleUtil.getLocalValue(name)}</span>
                    </div>
                    {vipCategory && <div>
                        <span>{Strings.category} :</span>
                        <span>{getOwnerVIPCategoryLabel(vipCategory!.CategoryId)}</span>
                    </div>}
                    <div>
                        <span>{Strings.emirates_id} :</span>
                        <span>{eid}</span>
                    </div>
                    <div>
                        <span>{Strings.email} :</span>
                        <span>{email}
                            {showEmailVerification &&
                                <button className={"btn btn_1 btn-sm ms-3"} onClick={this.onVerifyEmail}>
                                    {Strings.verify}
                                </button>}
                        </span>

                    </div>

                    <div>
                        <span>{Strings.Mobile_text} :</span>
                        <span>{mobile}</span>
                    </div>
                </div>
			</div>

			{ vipCategory && <div className="accordion accordian-style relationship-manager-detail">
				<div className="card">
					<div className="card-header">
						<button
							className="btn btn-link btn-block text-start relationship-manager-title collapsed"
							type="submit"
							onClick={ this.onAccountManager }>{ Strings.contact_your_account_manager }</button>
					</div>
				</div>
			</div> }
			{ isTabuUser && <GreenList/> }
			{ showOTP &&
				<SSOVerifyPopup
					api={ verifyApiAdapter }
					eventCategory={ "EditProfileInit" }
					noResend={ true }
					email={ email + "/" + mobile }
					onUserVerified={ this.onVerified }
					onDismiss={ this.onPopupDismiss }/> }
		</PageContent>;
	}

	onPopupDismiss = () => {
		setTimeout( () => {
			this.setState( { showOTP: false } );
		}, 10 );

	};
	onVerified = () => {
		setTimeout( () => {
			this.setState( { showOTP: false } );
			navigateWithInParent( "profile", "edit" );
		}, 10 );
	};
	onVerifyEmail = () => {
		navigateWithInParent( "profile", "verifyemail", undefined, { skipWait: true } );
	};

	private loadOwnerCategory() {
		VIPOwnerAPI.getOwnerCategoryDetails( getParticipantID()! ).then( ( resp: any ) => {
			trackEventWithData( "Profile", "VIPCategorySuccess" );
			if ( resp ) {
				this.setState( { vipCategory: resp }, () => {
					dispatch( Action.VIP_CATEGORY_CHANGED, resp );
				} );
			}
		} ).catch( reason => {
			trackEventWithData( "Profile", "VIPCategoryError", { message: reason } );
		} );
	}

	private onAccountManager = () => {
		navigate( "/mydld/account_manager" );
	};
}
